<section class="panel h0-a0-md1">
    <section class="data-zone">
        <ng-content select="[data-zone]"></ng-content>
    </section>
</section>
